import script from "./VideoDisplay.vue?vue&type=script&setup=true&lang=ts"
export * from "./VideoDisplay.vue?vue&type=script&setup=true&lang=ts"

import "./VideoDisplay.vue?vue&type=style&index=0&id=7b514c9a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b514c9a"]])

export default __exports__